import { COLOR, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_HEIGHT } from "~/styles/layout";
import { Z_INDEX } from "~/styles/z-index";

export const LIList = styled.li`
  position: relative;
  height: 100%;
  font-weight: ${FONT_WEIGHT.NORMAL};
`;

export const DivWrapper = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 108px;
  padding: 0 16px;
  font-size: ${FONT_SIZE.M}px;
  padding-top: 4px;
  border-bottom: 4px solid ${({ isActive }) => (isActive ? COLOR.YELLOW900.code : COLOR.GRAY100.code)};
  font-weight: ${({ isActive }) => (isActive ? FONT_WEIGHT.BOLD : FONT_WEIGHT.NORMAL)};

  a {
    height: 100%;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    line-height: 1;
  }
`;

export const ButtonIcon = styled.button`
  border: 2px solid ${COLOR.GRAY900.code};
  width: 24px;
  height: 24px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;
`;

export const DivBackDrop = styled.div`
  width: 100%;
  height: 100vh;
  height: calc(var(--1dvh, 1vh) * 100);
  height: 100dvh;
  background-color: rgba(${COLOR.GRAY100.rgb}, 0.6);
  position: fixed;
  top: ${GLOBAL_NAVI_HEIGHT.PC}px;
  left: 0;
  z-index: ${Z_INDEX.BACK_DROP};
  display: flex;
  justify-content: flex-end;
  overflow-y: hidden;
`;
